/* Fake Mink — cart drawer & light interactions, Shopify AJAX cart */
(function(){
  const $ = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => Array.from(r.querySelectorAll(s));
  const CART_SECTION = 'cart-drawer';

  // ── Drawer open/close
  const scrim = $('.scrim');
  const drawer = $('.drawer');
  function openCart(refresh){ if(!drawer) return; if (refresh !== false) refreshCart(); drawer.classList.add('open'); scrim && scrim.classList.add('open'); }
  function closeCart(){ if(!drawer) return; drawer.classList.remove('open'); scrim && scrim.classList.remove('open'); }
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-cart-open]');
    if (t) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-cart-close]')) { closeCart(); }
  });
  scrim && scrim.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

  // ── AJAX cart helpers
  // Cart mutations ask Shopify to re-render the drawer section in the same
  // request; all prices are Liquid-formatted server-side.
  async function addToCart(id, qty){
    const r = await fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items:[{ id, quantity: qty || 1 }], sections: CART_SECTION })
    });
    if (!r.ok) { const err = await r.json().catch(()=>({})); throw new Error(err.description || 'Add failed'); }
    return r.json();
  }
  async function updateCart(key, qty){
    const r = await fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id: key, quantity: qty, sections: CART_SECTION })
    });
    return r.json();
  }

  // ── Render drawer from server-rendered section HTML
  function sectionHtml(json){ return json && json.sections && json.sections[CART_SECTION]; }
  async function refreshCart(html){
    if (!html) {
      const r = await fetch(location.pathname + '?sections=' + CART_SECTION, {headers:{'Accept':'application/json'}});
      html = (await r.json())[CART_SECTION];
    }
    if (!html || !drawer) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newItems = doc.querySelector('.drawer .items');
    const newFt = doc.querySelector('.drawer .ft');
    const items = $('.items', drawer);
    const ft = $('.ft', drawer);
    if (newItems && items) items.innerHTML = newItems.innerHTML;
    if (newFt && ft) {
      ft.innerHTML = newFt.innerHTML;
      if (newFt.hasAttribute('hidden')) ft.setAttribute('hidden','');
      else ft.removeAttribute('hidden');
    }
  }

  document.addEventListener('click', async (e) => {
    const line = e.target.closest('.line');
    if (line && e.target.matches('[data-q]')) {
      const key = line.dataset.key;
      const d = parseInt(e.target.dataset.q, 10);
      const span = line.querySelector('.qty span');
      const current = parseInt(span && span.textContent, 10) || 0;
      const next = d === 0 ? 0 : Math.max(0, current + d);
      // optimistic feedback: show the new quantity at once, dim while the
      // server-rendered HTML is in flight, reconcile when it lands
      if (span) span.textContent = next;
      if (next === 0) line.style.opacity = '.4';
      drawer && drawer.classList.add('busy');
      try {
        const json = await updateCart(key, next);
        await refreshCart(sectionHtml(json));
      } catch (err) {
        await refreshCart();
      } finally {
        drawer && drawer.classList.remove('busy');
      }
    }
  });

  // ── Product form add
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const fd = new FormData(form);
    const id = parseInt(fd.get('id'), 10);
    const qty = parseInt(fd.get('quantity') || '1', 10);
    const btn = form.querySelector('[data-add-btn]');
    if (btn) btn.disabled = true;
    try {
      const json = await addToCart(id, qty);
      await refreshCart(sectionHtml(json));
      openCart(false);
    } catch (err) {
      alert(err.message);
    } finally {
      if (btn) btn.disabled = false;
    }
  });

  // ── Quick add (from grid card)
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    const id = parseInt(btn.dataset.quickAdd, 10);
    btn.disabled = true;
    try {
      const json = await addToCart(id, 1);
      await refreshCart(sectionHtml(json));
      openCart(false);
    } catch (err) {
      window.location.href = btn.dataset.href || '/';
    } finally {
      btn.disabled = false;
    }
  });

  // ── Search row toggle
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-search-toggle]')) {
      const row = $('.search-row');
      if (row) {
        row.classList.toggle('open');
        if (row.classList.contains('open')) { const i = row.querySelector('input'); i && i.focus(); }
      }
    }
  });

  // ── Mobile menu toggle
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-menu-toggle]');
    const menu = $('[data-mobile-menu]');
    if (!menu) return;
    if (toggle) {
      const open = menu.classList.toggle('open');
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    // close when tapping a link inside it
    if (e.target.closest('[data-mobile-menu] a')) {
      menu.classList.remove('open');
      menu.setAttribute('aria-hidden', 'true');
      const btn = $('[data-menu-toggle]');
      btn && btn.setAttribute('aria-expanded', 'false');
    }
  });

})();
